import React,{ useEffect, useContext, useState, useRef } from "react";
// Components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderPp } from "../../../components/Landing/Header/haederPp";
import { BreadCrumb } from "../../../components/Landing/Breadcrumb/breadcrumb.view";
import { Cards } from "../components/Cards/cards";
import { ModalVisualizarCronograma } from "./components/Avisos/ModalVisualizarCronograma";
import { ModalVisualizarPortafolio } from "./components/Avisos/ModalVisualizarPortafolio";
import { ModalVisualizarSocializaciones } from "./components/Avisos/ModalVisualizarSocializaciones";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { AiFillFacebook, AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { Footer } from "../../../components/Landing/Footer";
import { Banner } from "../components/Banner/Banner";
import { useNavigate } from "react-router-dom";
import getStorageUser from "../../../middlewares/GetStorageUser"
import { Form, Select, Input, Button, Collapse, Table, Empty, Row, Col, Popover, Space, Carousel } from "antd";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";
import { QuienParticipaOptions, tipoConvocatoria } from "../../../utils/dataSelectOptions";
import { TemplateContext } from "../../../utils/template_context";
import apiMaestras from "../../../api/Maestras/api-maestras";

import '../PeopleList.scss';

import segundaMobile from "../../../assets/pp/BANNER INICIO AGENDA.png";
import segundaDesktop from "../../../assets/pp/BANNER INICIO AGENDA.png";
import banner2 from "../../../assets/pp/Banner-resena-1-agenda.jpg"
import banner3 from "../../../assets/pp/Banner-resena-2-agenda.jpg"
import botonEstimulos from "../../../assets/pp/Boton Estimulos.jpg";
import botonCronograma from "../../../assets/pp/Boton Cronograma.jpg";
import botonSocializaciones from "../../../assets/pp/Banne-3.jpg";

import creativa from "../../../assets/landing/economicaCreativa.png"


// Hook
import { useLanding } from "../../../hooks/useLanding";
// style
import "../landing.style.scss";
import { color } from "html2canvas/dist/types/css/types/color";
import { borderBottomStyle } from "html2canvas/dist/types/css/property-descriptors/border-style";

const routes = [
  { icon: <></>, nombre: "Alcaldía de Medellín" },
  { icon: <></>, nombre: "Secretaría Cultura Ciudadana" },
  { icon: <></>, nombre: "Convocatorias de Presupuesto Participativo" },
];
const coloresEstado = {
  Abierta: "#21BA45",
  "En espera": "#EFC236",
  Cerrada: "#9F0505",
};
const { Panel } = Collapse;

const blockquoteStyle = {
  background: '#FFF',
  border: 0,
  margin: '1px',
  padding: 0,
  boxShadow: 'none',
  display: 'block'
};

const divStyle = {
  padding: '16px'
};

const linkStyle = {
  color: '#000',
  fontFamily: 'Arial, sans-serif',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '17px',
  textDecoration: 'none'
};

const divCarrusel = {
  backgroundColor: '#efefef',
  padding: '20px',
  borderRadius: '10px'
}

export const PpAgenda = () => {
  // state component
  const {
    principalState,
    getConvocatorias,
    getSiguientesConvocatorias,
    visibleButton,
    setPrincipalState,
    buscarconvocatorias,
    limipiarfiltros,
    loadingConvocatorias
  } = useLanding();

  const navigate = useNavigate();

  React.useEffect(() => {
    getLineasConvocatorias();
  }, []);

  useEffect(() => {
    // Crear un script y añadirlo al DOM
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Limpiar el script cuando el componente se desmonte
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const context = useContext(TemplateContext);
  const [LineasConvocatorias, setLineasConvocatorias] = React.useState([]);
  const [mostrarTabla, setMostrarTabla] = useState(false);

  const toggleVista = () => {
    setMostrarTabla(!mostrarTabla);
  };

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria, data) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
      return valueFilter[0].nombre;
    } else {
      if (data.nombre_convocatoria && data.nombre_convocatoria.includes("jurados")) {
        return "Banco de Jurados";
      } else {
        return "BEPS";
      }
    }
  };

  // component mounted
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, []);
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const [visualizarCronograma, setVisualizarCronograma] = useState<boolean>(false);
  const [visualizarPortafolio, setVisualizarPortafolio] = useState<boolean>(false);
  const [visualizarSocializaciones, setVisualizarSocializaciones] = useState<boolean>(false);

  const mostrarModalCronograma = () => {
    setVisualizarCronograma(true);
  }

  const mostrarModalPortafolio = () => {
    setVisualizarPortafolio(true);
  }

  const mostrarModalSocializaciones = () => {
    setVisualizarSocializaciones(true);
  }

  const contentStyle: React.CSSProperties = {
    width: '100%',
    objectFit: 'cover'
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 770);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 770);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const contentStyleC: React.CSSProperties = {
    width: "100%",
    height: "auto",
    objectFit: "cover"
  };
 
  const carouselRef = useRef<any>(null);
  const goToPrev = () => carouselRef.current?.prev();
  const goToNext = () => carouselRef.current?.next();

  return (
    <div>
      <Header />
      <HeaderPp />
      <div style={{ position: "relative", margin: "0 auto" }}>
        <Carousel
          ref={carouselRef}
          autoplay
          autoplaySpeed={3000}
          dots
          infinite
        >
          <div>
            <img src={segundaDesktop} alt="Banner 1" style={contentStyleC} />
          </div>
          <div>
            <img src={banner2} alt="Banner 2" style={contentStyleC} />
          </div>
          <div>
            <img src={banner3} alt="Banner 3" style={contentStyleC} />
          </div>
        </Carousel>
        {/* Flechas */}
        <button
          onClick={goToPrev}
          style={{
            position: "absolute",
            top: "50%",
            left: "16px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            border: "none",
            color: "white",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            cursor: "pointer"
          }}
        >
          <LeftOutlined style={{ fontSize: "18px" }} />
        </button>
        <button
          onClick={goToNext}
          style={{
            position: "absolute",
            top: "50%",
            right: "16px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            border: "none",
            color: "white",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            cursor: "pointer"
          }}
        >
          <RightOutlined style={{ fontSize: "18px" }} />
        </button>
      </div>
      <div className="container-fluid2 pt-5" style={{marginTop: '0'}}>
        <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:60}}>
          <strong>
            <h1 className="mb-5" style={{color: '#1e3a53'}}>
              AGENDA CULTURAL
            </h1>
          </strong>
          <h4 className="mb-3" style={{textAlign: 'center', marginTop: '10px'}}>
            Es la programación de encuentros y eventos ciudadanos de arte y cultura para la promoción y proyección de las expresiones culturales y del talento artístico de cada comuna y corregimiento del Distrito, que permite y fomenta el acceso y disfrute por parte de los habitantes del respectivo territorio.
          </h4>
        </div>
      </div>
      <br />
      <div className="container-fluid2 pt-5">
        <div className="row justify-content-center">
          <div className="col-md-3">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={botonEstimulos}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">CRONOGRAMA</h3>
                  <p className="card2-description">
                    Te invitamos a conocer la programación de los eventos culturales que llenarán de arte, música, danza y tradición las comunas de nuestra ciudad.
                  </p>
                  <p className="card2-description">
                    Explora el cronograma completo y entérate de las fechas, horarios y lugares donde podrás disfrutar de festivales, presentaciones artísticas, recorridos y muchas actividades pensadas para toda la familia.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="video-section">
        <div className="video-wrapper">
          <div className="video-frame">
            <iframe
              src="https://drive.google.com/file/d/1JSVSP611c4swqrW3rr5kgXi4u8VUawel/preview"
              allow="autoplay"
              allowFullScreen
              loading="lazy"
              title="Video"
            ></iframe>
          </div>
          <div className="video-text">
            <h2>¿Por qué ser parte de la Convocatoria de Estímulos 2025?</h2>
            <p>
            Este video te muestra cómo tu creatividad puede transformar la ciudad. Escucha las voces que ya han hecho parte de esta experiencia y descubre por qué tu proyecto también puede marcar la diferencia.
            </p>
            <div className="social-icons">
              <a href="#"><AiFillFacebook /></a>
              <a href="#"><AiFillInstagram /></a>
              <a href="#"><AiFillYoutube  /></a>
            </div>
          </div>
        </div>
      </section>
      <ModalVisualizarCronograma
        visualizar={visualizarCronograma}
        setVisualizar={setVisualizarCronograma}
      />
      <ModalVisualizarPortafolio
        visualizar={visualizarPortafolio}
        setVisualizar={setVisualizarPortafolio}
      />
      <ModalVisualizarSocializaciones
        visualizar={visualizarSocializaciones}
        setVisualizar={setVisualizarSocializaciones}
      />
      <Footer />
    </div>
  );
};
